import React from 'react';
import { PDFIcon } from '../../../../components/Icon/Icon';

const Body = () => (
    <>
        <div className="aboutTopPad"></div>
        The core business of JD Group is retail. Throughout our multiple store fascias, we aim to
        provide customers with an enjoyable retail experience. This involves displaying the latest
        products from the very best brands in an attractive, well-lit environment capable of
        sustaining a comfortable ambient temperature for customers and colleagues alike. We accept
        that all our businesses (regardless of territory) must mirror the JD Group commitment
        towards minimising the impact of climate change, using progressive behaviours and investment
        to reduce both energy usage, and associated carbon emissions.
        <br />
        <br />
        Independent verification of the Group’s continued progress on the management and reduction
        of our environmental footprint has been provided by our score from the December 2020 Carbon
        Disclosure Project (‘CDP’) audit. JD Group was awarded a milestone score of ‘A-’ for the
        Carbon Management category, placing JD Group in the ‘Leadership’ band of respondents, a full
        three grades higher that the retail average of ‘C’. In addition to the recognition of our
        progress in managing carbon-related emissions, the fantastic ‘Water Security’ progress made
        by our Own Brand team has been endorsed by way of a ‘B’ score for this CDP audit, moving JD
        Group two grades above the retail average score of ‘C’ for this vital
        bio-diversity-impacting category.
        <ul className="column">
            <li>
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://files.jdplc.com/pdf/December-2020-CDP-Climate-Change-Report.pdf"
                    title="JD Sports Fashion plc – CDP Score Report"
                >
                    <PDFIcon name="energy/cdp-score.png" />
                    JD Sports Fashion plc – CDP Score Report
                </a>
            </li>
        </ul>
        <h2>Carbon Management Programme – 2020/21 Progress Review</h2>Up to, and including the
        reporting period for 2020, the Group maintained a Carbon Management Programme (‘CMP’)
        sponsored by our Chief Financial Officer and reviewed at regular intervals. Following the
        establishment of the Group’s ESG Committee, the management of carbon, water, waste, and
        other key environmental measures shall be measured against an updated set of objectives.
        <br />
        <br />
        To ensure continuity between the last reporting period and this, we have provided an update
        on in-year progress in the original format (below). The 2020/21 objectives can be found in
        our{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/reports/annual-report-and-accounts-2020.pdf"
            title="Annual Report"
            target="_blank"
            rel="noopener noreferrer"
        >
            Annual Report.
        </a>
        <br />
        <br />
        <table className="table-progress-review">
            <tbody>
                <tr>
                    <th className="header-obj">Objective</th>
                    <th className="header-action-progress">Action and Progress</th>
                </tr>
                <tr className="progress-row">
                    <td className="col-objectives">
                        <div className="number">1.</div>
                        <p className="objective">Reduce energy usage in non-trading periods</p>
                    </td>
                    <td className="col-action-progress">
                        <p>
                            {' '}
                            The Group has invested in Building Management Systems (BMS) in 399 of
                            its highest energy consuming stores, the majority of which are in the
                            UK. These investments cover all fascias and delivered average annual
                            energy savings of 13.1% compared to usage prior to BMS-install (using
                            baseline figures compared across a number of sites). The BMS-related
                            energy saving equals a carbon reduction of 1,657t CO2. During the
                            Period, we trialed additional energy reduction methods within our BMS
                            sites. In Summer 2019 and Winter 2019/20 we reduced our heating and
                            cooling set-points, decreasing our energy usage and related CO2 impact
                            reducing annual electricity consumption by 5%, which equates to 2.3 GWh,
                            or 584 fewer tonnes CO2 of carbon emissions. BMS shall continue to be
                            installed within new JD stores as standard, with further retrofits and
                            other BMS trials scheduled for the Period ahead.{' '}
                        </p>
                    </td>
                </tr>
                <tr className="progress-row">
                    <td className="col-objectives">
                        <div className="number">2.</div>
                        <p className="objective">
                            {' '}
                            Reduce energy usage through investment in lighting technology{' '}
                        </p>
                    </td>
                    <td className="col-action-progress">
                        <p>
                            {' '}
                            Group investment in LED and energy reduction has continued during the
                            Period. Our standard retail lighting scheme uses LED lamps with motion
                            sensors in both changing room and non-retail areas. Our Head Office site
                            in Bury was fully retro-fitted with LEDs within the Period, delivering a
                            reduction of over 60% in energy usage vs the previous lighting system.{' '}
                        </p>
                    </td>
                </tr>
                <tr className="progress-row">
                    <td className="col-objectives">
                        <div className="number">3.</div>
                        <p className="objective">
                            {' '}
                            Reduce energy usage through colleague awareness and training{' '}
                        </p>
                    </td>
                    <td className="col-action-progress">
                        <p>
                            {' '}
                            Retail colleagues have a key role to play in the execution of the CMP.
                            All new staff receive online training in energy management as part of
                            our induction programme. We have documented and published (via intranet
                            and employee magazines) case study material on our achievements. This
                            ‘celebration of success’ increases employee awareness the importance of
                            energy reduction.{' '}
                        </p>
                    </td>
                </tr>
                <tr className="progress-row">
                    <td className="col-objectives">
                        <div className="number">4.</div>
                        <p className="objective">
                            {' '}
                            Ensure that the CMP applies to all businesses, in all territories{' '}
                        </p>
                    </td>
                    <td className="col-action-progress">
                        <p>
                            {' '}
                            For Group acquisition stores, we work closely with local management
                            teams to identify carbon reduction opportunities. Store energy
                            performance reporting has been introduced by Fascia for the UK retail
                            operation and also for JD Gyms. The reporting includes store energy
                            performance league tables (and performance indicators) comparing year on
                            year energy performance. A verified baseline for energy has also been
                            developed to show continual performance improvement. The reporting
                            provided on a quarterly period has allowed the targeting of poor energy
                            performing stores and investigation action to be undertaken.
                        </p>
                    </td>
                </tr>
                <tr className="progress-row">
                    <td className="col-objectives">
                        <div className="number">5.</div>
                        <p className="objective">
                            {' '}
                            Purchase 'Green' (renewable) energy wherever possible
                        </p>
                    </td>
                    <td className="col-action-progress">
                        <p>
                            {' '}
                            100% of the Group’s UK and Irish electricity is ‘Green’ energy from
                            natural, renewable sources. Within the Period, France joined the
                            Netherlands, Italy, Belgium, Sweden, Finland, Denmark and Germany on
                            100% Green energy. Acquisition businesses are migrated to the Group’s
                            sustainable supply contracts (legacy contractual obligation usage).
                        </p>
                    </td>
                </tr>
            </tbody>
        </table>
        <br />
        To understand more about what we are doing to reduce energy usage across our business,
        please look at the case study below:
        <br />
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/reducing-energy-usage.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Reducing Energy Usage"
                >
                    <PDFIcon name="energy/reducing-energy.png" />
                    Reducing Energy Usage
                </a>
            </li>
        </ul>
        <h2>Environmental Performance Reporting - Summary</h2>We continue to build upon the success
        of the Group’s long-standing energy reduction achievements and management of environmental
        issues within our core UK operations. Our environmental performance reporting is supported
        by a team of key colleagues and specialist energy and environment consultants. Our reporting
        system captures all key energy usage for buildings and business travel, carbon emissions,
        water use, waste and recycling, in addition to acting as a register for our audit data for
        all energy related reporting requirements and legislation.
        <br />
        <br />
        To January 2020, progress has been made in the following areas:
        <br />
        <ul className="list">
            <li>
                Improved energy efficiency. Reducing our usage via improved management reporting,
                greater use of benchmarks and investing energy infrastructure (e.g. ‘Smart’ metres)
            </li>
            <li>
                Reducing organisational waste - by using improved site and DC reporting to increase
                the number of operationally feasible recyclable waste streams within our core
                operations. The Group achieved ‘Zero waste to landfill’ certification for our
                largest global operations site (Kingsway DC) in February 2020.
            </li>
            <li>
                Production and distribution of quarterly Environmental Performance Reporting for
                store energy and water usage
            </li>
            <li>
                The team has successfully completed and delivered on the Group’s data gathering and
                reporting obligations under the Energy Efficiency Directive (EED) / Energy Saving
                Opportunity Scheme (ESOS) ahead of the December 2019 deadline
            </li>
            <li>
                Collation of Scope 3 emissions data from our major third-party logistic providers.
                This will assist in implementing our Science Based Target initiative (SBTi)
                submission this year, supporting the provision of enhanced Scope 3 emission
                reporting
            </li>
        </ul>
        <br />
        To understand more about how we are progressing with Science Based Targets, please look at
        the case study below:
        <br />
        <ul className="column">
            <li>
                <a
                    href="https://files.jdplc.com/pdf/case-studies/science-based-targets.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Science Based Targets"
                >
                    <PDFIcon name="energy/targets.png" />
                    Science Based Targets
                </a>
            </li>
        </ul>
        <h2>More information</h2>If you would like to find out further information on our energy
        policies including our targets for 2021, please read our{' '}
        <a
            className="link"
            href="https://files.jdplc.com/pdf/reports/annual-report-and-accounts-2020.pdf"
            title="Annual Report"
            target="_blank"
            rel="noopener noreferrer"
        >
            Annual Report
        </a>{' '}
        2020.
    </>
);

export const content = {
    image: 'https://files.jdplc.com/images/about/energy.png',
    body: Body,
};
